import { Injectable } from "@angular/core";
import { ApplicationPool } from "./application.pool";
import { BehaviorSubject, Observable, Subject } from "rxjs";

export { ApplicationPool as DataPool };

@Injectable({
  providedIn: "root",
})
export class MessageService {
  private messageSubject = new BehaviorSubject<any>(null);
  private submitSubject = new BehaviorSubject<any>(null);
  private openSubject = new BehaviorSubject<any>(null);

  private timeoutLevel = 0;

  public sendMessage(message: string, centerPosition?: boolean) {
    this.messageSubject.next({ text: message, centerPosition });
    setTimeout((level = ++this.timeoutLevel) => {
      // tslint:disable-next-line:triple-equals
      if (level == this.timeoutLevel) {
        this.clearMessage();
      } // else another message has been sent
    }, 5000);
  }

  public clearMessage() {
    this.messageSubject.next(null);
  }

  public getMessage(): Observable<any> {
    return this.messageSubject.asObservable();
  }
  public hasMessage(): boolean {
    return this.messageSubject.value != null;
  }

  public sendOpen(message: string, ngHref: string) {
    this.openSubject.next({ text: message, ngHref });
    setTimeout((level = ++this.timeoutLevel) => {
      // tslint:disable-next-line:triple-equals
      if (level == this.timeoutLevel) {
        this.clearOpen();
      } // else another message has been sent
    }, 7000);
  }

  public sendSubmitMessage(
    message: string,
    params: (
      | { label: string; e: () => void }
      | { label: string; e: () => void }
    )[]
  ) {
    this.submitSubject.next({ text: message, params });
  }
  public hasSubmitMessage(): boolean {
    return this.submitSubject.value != null;
  }

  public clearSubmitMessage() {
    this.submitSubject.next(null);
  }

  public clearOpen() {
    this.openSubject.next(null);
  }

  public getOpen() {
    return this.openSubject.asObservable();
  }

  public getSubmitMessage(): Observable<any> {
    return this.submitSubject.asObservable();
  }
}
